import PopupComponent from '@components/std-components/Popup'
import { CentricTypography } from '@core/component/CentricTypography'
import { MenuItem } from '@material-ui/core'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import RollupSplitActionsButtons from './RollupSplitActionsButton'
export interface RollupSplitActionsProps {
  isIconButton: boolean
  iconTooltipLabel?: string
  iconImageSrc?: any
  buttonLabel?: string | any
  disableButton?: boolean
  actionsProductId?: string
  setActionProductId?: any
  menuOptions?: any
  isCaptureSize?: boolean
  hasSizes?: boolean
  rowData?: any
  onActionClick?: any
}

const RollupSplitActions: FC<RollupSplitActionsProps> = ({
  isIconButton,
  iconTooltipLabel,
  iconImageSrc,
  buttonLabel,
  disableButton,
  actionsProductId,
  setActionProductId,
  menuOptions,
  isCaptureSize,
  hasSizes = true,
  rowData,
  onActionClick
}) => {
  const [open, setOpen] = useState(false)
  const { t } = useTranslation()
  const handleTriggerClick = id => {
    if (isIconButton) {
      setActionProductId(id)
    } else {
      setOpen(true)
    }
  }
  return isCaptureSize ? (
    <PopupComponent
      trigger={
        <div>
          <RollupSplitActionsButtons
            isIconButton={isIconButton}
            iconTooltipLabel={iconTooltipLabel}
            disableButton={disableButton}
            iconImageSrc={iconImageSrc}
            buttonLabel={buttonLabel}
            handleButtonClick={() => handleTriggerClick(rowData?.id)}
          />
        </div>
      }
      nested={true}
      position='right top'
      disabled={disableButton}
      arrow={true}
      open={isIconButton ? actionsProductId === rowData?.id : open}
      contentStyle={{
        width: 'fit-content',
        padding: '10px',
        zIndex: 3000,
        boxShadow: 'rgba(0, 0, 0, 0.15) 0px 0px 10px 0px'
      }}
      onOpen={() => handleTriggerClick(rowData?.id)}
      onClose={() => {
        isIconButton && setActionProductId('')
        setOpen(false)
      }}
    >
      <div>
        {menuOptions.map(item => {
          return item?.showCurrentOperation(isCaptureSize) ? (
            <MenuItem
              onClick={() => {
                onActionClick(item?.id)
                isIconButton && setActionProductId('')
                setOpen(false)
              }}
              key={item?.id}
              disabled={item?.isOptionDisabled(hasSizes)}
            >
              <CentricTypography variant={'caption'}>
                {t(item?.key, item.label)}
              </CentricTypography>
            </MenuItem>
          ) : null
        })}
      </div>
    </PopupComponent>
  ) : (
    <RollupSplitActionsButtons
      isIconButton={isIconButton}
      iconTooltipLabel={iconTooltipLabel}
      disableButton={disableButton}
      iconImageSrc={iconImageSrc}
      buttonLabel={buttonLabel}
      handleButtonClick={() => onActionClick()}
    />
  )
}

export default RollupSplitActions
